import React from 'react';

import cn from 'classnames';
import { each } from 'lodash';
import PropTypes from 'prop-types';

import { Button, Text } from 'modules/common';

// Parent div should have relative className

export const setError422 = (err, setFieldError) => {
  if (err?.status === 422) {
    each(err?.response?.errors, (v, k) => {
      if (v[0]) setFieldError(k, v[0]);
    });
  }
};

const FormUpdateButtons = React.forwardRef((props, ref) => {
  const {
    label,
    isLoading,
    isDirty,
    onCancel,
    onSubmit,
    isNew,
    primaryButtonProps,
    disabled,
  } = props;

  return (
    <div
      ref={ref}
      className={cn(
        'p-3 md:px-5 bg-gray-800 fixed md:absolute bottom-0 left-0 flex items-center w-full transform duration-200 z-40',
        {
          'translate-y-0 ease-out': isDirty,
          'translate-y-full ease-in': !isDirty,
        }
      )}
    >
      <div className="flex-1">
        <Text
          weight="semibold"
          color="primitive-white"
          className="text-caption md:text-subheading"
        >
          {label}
        </Text>
      </div>

      <div className="flex items-center gap-ds-8">
        <Button
          className="ds-btn"
          label="Cancel"
          disabled={disabled}
          isLoading={isLoading}
          onClick={onCancel}
        />
        <Button
          className="ds-btn ds-primary"
          label={isNew ? 'Add' : 'Update'}
          disabled={disabled}
          isLoading={isLoading}
          onClick={onSubmit}
          withScrollOnError
          {...primaryButtonProps}
        />
      </div>
    </div>
  );
});

FormUpdateButtons.defaultProps = {
  isNew: false,
  isLoading: false,
  isDirty: false,
  disabled: false,
  label: 'You have unsaved changes',
  primaryButtonProps: {},
};

FormUpdateButtons.propTypes = {
  isNew: PropTypes.bool,
  label: PropTypes.string,
  isLoading: PropTypes.bool,
  isDirty: PropTypes.bool,
  disabled: PropTypes.bool,
  onCancel: PropTypes.instanceOf(Function).isRequired,
  onSubmit: PropTypes.instanceOf(Function).isRequired,
  primaryButtonProps: PropTypes.instanceOf(Object),
};

export default FormUpdateButtons;
